
import { useLoaderStore } from "../util/useLoaderStore";
const BASE_URL = import.meta.env.VITE_API_BASE_URL; // Replace with your backend URL
// const BASE_URL =  "https://api-sales.tecsg.com.sg/"

export const apiService = async (endpoint, method = "GET", body = null, headers = {}) => {
    const token = localStorage.getItem("authToken"); // Retrieve the token from localStorage

    const defaultHeaders = {
      ...(body instanceof FormData ? {} : { "Content-Type": "application/json" }), // Skip Content-Type for FormData
      Authorization: token ? `Bearer ${token}` : "", // Add the token if it exists
      ...headers,
    };
  
    const { startLoading, stopLoading } = useLoaderStore.getState();

    startLoading();
  
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method,
      headers: defaultHeaders,
      body: body instanceof FormData ? body : body ? JSON.stringify(body) : null, // Pass FormData directly
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
  finally {
    stopLoading();
  }
};
// Centralized response handling
const handleResponse = async (response) => {
  if (!response.ok) {
    if (response.status === 401) {
      // Token is invalid or expired
      localStorage.removeItem("authToken"); // Clear the token
      
      // toast.error("Session expired. Please log in again.");
      window.location.href = "/login"; // Redirect to login page
      throw new Error("Session expired. Please log in again.");
    }

    // Parse error response
    const errorData = await response.json();
   
    throw new Error(errorData.message || "Something went wrong");
  }

  // Parse and return successful response
  return await response.json();
};